import * as React from "react";
import {
  MdPeople,
  MdInsertDriveFile,
  MdAttachMoney,
  MdFavorite,
  MdQuestionAnswer
} from "react-icons/md";

/** Custom types */
import { NavItemType } from "../CustomTypes";

export const SuperUser: Array<NavItemType> = [
  {
    to: "/consumer/team",
    role: "SUPER_USER",
    title: "Team",
    icon: <MdPeople size="1.3em" />
  },
  {
    to: "/consumer/reports",
    role: "SUPER_USER",
    title: "Reports",
    icon: <MdInsertDriveFile size="1.3em" />
  },
  {
    to: "/consumer/purchased",
    role: "SUPER_USER",
    title: "Purchased",
    icon: <MdAttachMoney size="1.3em" />
  },
  {
    to: "/consumer/account",
    role: "SUPER_USER",
    title: "Account",
    icon: <MdFavorite size="1.3em" />
  },
  {
    to: "/consumer/about-roots",
    role: "USER",
    title: "Roots",
    icon: <MdQuestionAnswer size="1.3em" />
  }
];



// WEBPACK FOOTER //
// ./src/Navigation/SuperUserRoutes.tsx